var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',_vm._g({attrs:{"name":_vm.name},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"after-enter":_vm.afterEnter,"before-leave":_vm.beforeLeave,"leave":_vm.leave}},_vm.$listeners),[_vm._t("default",null,null,{ isOverflowing: _vm.isOverflowing })],2)
}
var staticRenderFns = []

export { render, staticRenderFns }